import { Box, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import DoneIcon from '@mui/icons-material/Done';
import { useTranslation } from 'react-i18next';

const GREEN = '#388C2D';
const YELLOW = '#FD8200';

export type GRStatus = 'green' | 'yellow';

interface GoldenRuleStatusBoxProps {
  reach: number;
  grReach: number | null | undefined;
}

export function computeGRStatus(
  reach: number,
  grReach: number | null | undefined
): { status: GRStatus; percentage: number } | null {
  if (!grReach) return null;
  const percentage = Math.round((reach / grReach) * 10000) / 100;
  if (percentage >= 100) return { status: 'green', percentage };
  return { status: 'yellow', percentage };
}

export default function GoldenRuleStatusBox({
  reach,
  grReach,
}: GoldenRuleStatusBoxProps) {
  const { t } = useTranslation();
  const result = computeGRStatus(reach, grReach);

  if (!result) return null;

  const { status, percentage } = result;
  const color = status === 'green' ? GREEN : YELLOW;

  return (
    <Box display="flex" alignItems="center">
      <Box
        sx={{
          position: 'relative',
          width: '100px',
          height: '57px',
          border: `2px solid ${color}`,
          borderRadius: '6px',
          ml: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          sx={{
            position: 'absolute',
            top: 0,
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
            px: '4px',
            width: '60px',
            color: '#525F81',
            fontSize: '11px',
            fontWeight: 400,
            lineHeight: 1,
            textAlign: 'center',
            whiteSpace: 'pre-line',
            zIndex: 1,
            background: '#F6F6F6',
          }}
        >
          {t('mediaPlanning.goldenRuleFulfilled')}
        </Typography>
        <Typography
          sx={{
            color,
            fontWeight: 700,
            fontSize: '20px',
            lineHeight: '100%',
            mt: '8px',
          }}
        >
          {percentage} %
        </Typography>
      </Box>
      <Box sx={{ ml: '24px', display: 'flex', alignItems: 'center' }}>
        {status === 'yellow' && (
          <WarningAmberIcon sx={{ color, width: '28px', height: '47px' }} />
        )}
        {status === 'green' && (
          <DoneIcon sx={{ color, width: '28px', height: '47px' }} />
        )}
      </Box>
    </Box>
  );
}
